// Résolution des libellés d'enums CRM via i18n (couleurs restent dans constants.js).
export const enumLabel = (t, group, k, map) =>
  t(`crm.enum.${group}.${k}`, { defaultValue: (map && (typeof map[k] === "string" ? map[k] : map[k]?.label)) || k });

export const enumOpts = (t, group, map) =>
  Object.keys(map).map((k) => ({ k, v: enumLabel(t, group, k, map) }));
